import Cookies from "js-cookie";

function init() {
    replaceImgByRealSvgs();
    maybeAutoRedirectUserToUserLang();
}
if (
    document.readyState === "interactive" ||
    document.readyState === "complete" &&
        (name === "DOMContentLoaded" || name === "load")
) {
    setTimeout(init); // Using setTimeout doesn't block main thread and tells browser to run it when it can
} else {
    document.addEventListener("DOMContentLoaded", init);
}

function lateInit() {
    setUserLangInNewsletterForm();
    setUserLangInOtherForms();
    trimFormidableLabelIdFormidable();
    trimFormidableSelectOptions();
    setPremiumRessourceModal();
    setLivreBlancFormLogicAndEvents();
    setSelectedLangInCookie();
}
window.addEventListener("load", lateInit);

const setPremiumRessourceModal = () => {
    // Move all forms to the bottom of the page
    const modalId = "modal-premium-ressource";
    const modalEl = document.getElementById(modalId);
    if (!modalEl) return;

    modalEl.addEventListener("click", (ev) => {
        if (ev.target === ev.currentTarget) {
            ev.stopPropagation();
            modalEl.close();
        }
    });

    const formDivUuid = "1722532809000-4704980724";
    const hubspotWrapperFormId = "hbspt-form-" + formDivUuid;

    setPremiumFormLogicAndEvents();
    if (window?.WP_Grid_Builder) {
        if (
            WP_Grid_Builder.instance(1)?.element.classList.contains(
                "wpgb-enabled",
            )
        ) {
            console.log("🔍", "wpgb late init"); // eslint-disable-line
            WP_Grid_Builder.instance(1).grid.on(
                "layout",
                () => setPremiumFormLogicAndEvents(),
            );
        } else {
            WP_Grid_Builder.on("init", (wpgb) => {
                wpgb.grid.on("layout", () => setPremiumFormLogicAndEvents());
            });
        }
    }

    function setPremiumFormLogicAndEvents() {
        // Set click events on form elements
        const triggerEls = document.querySelectorAll(
            ".js-trigger-premium-form",
        );
        if (!triggerEls.length) return;

        triggerEls.forEach((triggerEl) => {
            if (triggerEl.hasOwnProperty("_premiumInit")) return;
            const selectEl = triggerEl?.closest(".docs-wrapper")?.querySelector(
                ".doc-lang-list",
            );
            if (selectEl) {
                selectEl.addEventListener("change", function (ev) {
                    triggerEl.dataset.doc = this.value;
                    triggerEl.href = "javascript:;";
                });
            }

            triggerEl.addEventListener("click", (ev) => {
                const postId = ev?.target?.dataset?.post;
                let docUrl = ev?.target?.dataset?.doc;
                docUrl = docUrl ? atob(docUrl) : "";
                if (!docUrl) {
                    console.error("No doc url provided.", ev);
                    return;
                }

                const oldHubspotForm = document.getElementById(
                    hubspotWrapperFormId,
                );
                if (oldHubspotForm) oldHubspotForm.remove();

                // Bypass modal & hubspot form to download directly the ressource
                const userAlreadySubmittedForm = localStorage.getItem(
                    "user_submitted_premium_ressource_form",
                );
                if (userAlreadySubmittedForm) {
                    // Trigger ressource download
                    const aElement = document.createElement("a");
                    const fileName = new URL(docUrl)?.pathname?.split(
                        "/",
                    ).at(-1);
                    aElement.setAttribute("download", fileName);
                    aElement.href = docUrl;
                    aElement.click();
                } else {
                    // INFO: Must use "jQuery", it doesn't works with native JS
                    jQuery(document).ready(function ($) {
                        $(document).on(
                            "frmFormComplete",
                            function (ev, formEl, response) {
                                const formID = formEl.querySelector(
                                    'input[name="form_id"]',
                                )?.value;
                                if (!formID || formID != "8") {
                                    console.log(
                                        "🔍",
                                        "Not Premium ressource form.",
                                    ); // eslint-disable-line
                                    return;
                                }

                                // Trigger ressource download
                                const aElement = document.createElement("a");
                                const fileName = new URL(docUrl)?.pathname
                                    ?.split(
                                        "/",
                                    ).at(-1);
                                aElement.setAttribute("download", fileName);
                                aElement.href = docUrl;
                                aElement.click();

                                // Set in storage to prevent display form again for same user
                                localStorage.setItem(
                                    "user_submitted_premium_ressource_form",
                                    true,
                                );
                            },
                        );
                    });

                    // Customize modal to match current ressource (title, post id...etc)
                    if (postId) {
                        modalEl.setAttribute("data-post", postId);
                    }
                    let modalTitle = "";
                    if (triggerEl.closest("article.doc")) {
                        modalTitle = triggerEl.closest("article.doc")
                            ?.querySelector(".doc-title").textContent;
                    }
                    if (!modalTitle && triggerEl.closest(".software")) {
                        modalTitle = triggerEl.closest(".software")
                            ?.querySelector(".software-title").textContent;
                    }
                    modalTitle
                        ? modalEl.querySelector(".modal-text").textContent =
                            modalTitle
                        : "";
                    modalEl.showModal();
                }
            });

            triggerEl._premiumInit = true;
        });
    }
};

const setLivreBlancFormLogicAndEvents = () => {
    const docFileEl = document.querySelector("#lb_file_url");
    if (!docFileEl) {
        return;
    }

    let docUrl = docFileEl?.value;
    docUrl = docUrl ? atob(docUrl) : "";
    if (docFileEl && !docUrl) {
        console.error("No doc url provided.");
        return;
    }

    // INFO: Must use "jQuery", it doesn't works with native JS
    jQuery(document).ready(function ($) {
        $(document).on("frmFormComplete", function (ev, formEl, response) {
            const formID = formEl.querySelector('input[name="form_id"]')?.value;
            if (!formID || formID != "8") {
                console.log("🔍", "Not Premium ressource form."); // eslint-disable-line
                return;
            }

            // Trigger ressource download
            const aElement = document.createElement("a");
            const fileName = new URL(docUrl)?.pathname?.split("/").at(
                -1,
            );
            aElement.setAttribute("download", fileName);
            aElement.href = docUrl;
            aElement.click();
        });
    });
};

/**
 * Save lang selected by user in weglot dropdown to store it in a cookie
 * @returns void
 */
const setSelectedLangInCookie = () => {
    const countryLangEls = [
        ...document.querySelectorAll(".country-selector a"),
    ];
    if (!countryLangEls.length) return;

    countryLangEls.map((countryLangEl) =>
        countryLangEl.addEventListener("click", (ev) => {
            const selectedLang = ev?.currentTarget?.parentNode?.dataset?.l;
            Cookies.set("pib-remember-lang", selectedLang, {
                sameSite: "Strict",
                secure: true,
                path: "/",
            });
        })
    );
};

/*
 * Remplace toutes les images au format svg avec la classe svg en SVG développé
 * dans le code pour pouvoir modifié les svg
 */
const replaceImgByRealSvgs = () => {
    const convertImgToSvg = (imgEl) => {
        if (!imgEl) {
            console.error("SVG error: Missing img element arg");
            return;
        }

        // Get HTML el from jQuery obj
        if (imgEl?.length) {
            imgEl = imgEl[0];
        }

        let imgURL = imgEl.getAttribute("src");
        const imgHeight = imgEl.getAttribute("height");
        const imgWidth = imgEl.getAttribute("width");

        /** Fix WP Rocket (by getting the lazy src) */
        const isLazyloaded = imgEl.hasAttribute("data-lazy-src");
        if (isLazyloaded) imgURL = imgEl.getAttribute("data-lazy-src");

        // Prevent ajax/fetch of non image ressource
        if (!imgURL || !imgURL.endsWith(".svg")) {
            // console.log(`<${imgEl.localName}.${imgEl.classList[0]}> is not a .svg file`, imgEl)
            return;
        }

        // Fetch img
        fetch(imgURL, {
            method: "GET", // or 'PUT'
            headers: { "Content-Type": "application/xml" },
        })
            // Turn response into plain text
            .then((response) => response.text())
            // Turn text into xml DOM element
            .then((str) =>
                new window.DOMParser().parseFromString(str, "text/xml")
            )
            // Work with XML
            .then((xml) => {
                // On prend le tag SVG et on zappe le reste
                const svgEl = xml.querySelector("svg");

                // Ajout de l'ID de l'image au svg qui remplace l'image
                if (imgEl?.id) svgEl.setAttribute("id", imgEl.id);

                // Ajout de la classe de l'image au svg qui remplace l'image
                if (imgEl?.className) {
                    svgEl.setAttribute(
                        "class",
                        `${imgEl.className} is-replaced-svg`,
                    );
                }

                // Supprimez toutes les balises XML invalides selon http://validator.w3.org
                svgEl.removeAttribute("xmlns:a");

                if (imgHeight) svgEl.setAttribute("height", imgHeight);
                if (imgWidth) svgEl.setAttribute("width", imgWidth);

                // Vérifiez si le viewport est configurée, si le viewport n'est pas configurée, le SVG n'augmentera pas.
                if (
                    !svgEl.getAttribute("viewBox") &&
                    svgEl.getAttribute("height") && svgEl.getAttribute("width")
                ) {
                    svgEl.setAttribute(
                        "viewBox",
                        "0 0 " + svgEl.getAttribute("height") + " " +
                            svgEl.getAttribute("width"),
                    );
                }

                // Remplace l'image par le nouveau SVG
                imgEl.replaceWith(svgEl);
            })
            .catch((error) => {
                console.error("SVG Error:", error);
            });
    };

    /** Process all ".svg" images */
    const imgsSvgs = [...document.querySelectorAll('.svg, img[src$=".svg"]')];
    imgsSvgs.map((el) => convertImgToSvg(el));
};

/**
 *  Store user lang in newsletter form
 *
 *  @returns void
 */
const setUserLangInNewsletterForm = () => {
    const userLangNewsletterFormInput = document.getElementById(
        "field_newsletter_lang",
    );
    if (!userLangNewsletterFormInput) return;

    userLangNewsletterFormInput.parentNode.querySelector("label").textContent =
        "newsletter_lang";
    userLangNewsletterFormInput.value = document.documentElement.getAttribute(
        "lang",
    );
};

/**
 *  Store user lang in other forms like "contact", "demande de devis"
 *  (to prevent ID conflict with newsletter which is on every page)
 *
 *  @returns void
 */
const setUserLangInOtherForms = () => {
    const userLangFormFieldEl = document.getElementById("field_user_lang");
    if (!userLangFormFieldEl) return;

    // ACF field
    if (userLangFormFieldEl?.tagName === "DIV") {
        userLangFormFieldEl.querySelector("input").value = document
            .documentElement.getAttribute("lang");
    } else {
        // Formidable field
        userLangFormFieldEl.parentNode.querySelector("label").textContent =
            "newsletter_lang";
        userLangFormFieldEl.value = document.documentElement.getAttribute(
            "lang",
        );
    }
};

/**
 * Redirect user to his preferred lang on first visit
 * (redirect feature using JS to bypass html cache)
 * INFO: WeGlot uses "WG_CHOOSE_ORIGINAL" cookie & "wg-choose-original" GET param to set/get if a user selected a lang which is / not the original site lang
 * (true if user lang, false otherwise)
 */
const maybeAutoRedirectUserToUserLang = () => {
    // Get current url without hash / query strings to compare with hreflang url
    const currentUrl = window?.location?.href;
    const currentUrlObj = new URL(currentUrl);
    currentUrlObj.search = "";
    currentUrlObj.hash = "";
    const cleanCurrentUrl = currentUrlObj.toString();

    // Get value from cookie if user selected a lang in dropdown, fallback on navigator lang
    const userOriginalLang = Cookies.get("pib-remember-lang") ||
        navigator.language.split("-")?.[0];

    // Look for alternate lang url
    let alternateLangUrl = document.querySelector(
        `link[rel="alternate"][hreflang="${userOriginalLang}"]`,
    )?.href;
    const siteHasUserLang = !!alternateLangUrl;
    if (!siteHasUserLang || cleanCurrentUrl === alternateLangUrl) {
        return;
    }

    // Add back query strings if there was some
    alternateLangUrl += window?.location?.search;

    // Redirect user
    console.log(
        "🔍",
        "User will be redirected from current url to alternate lang url",
        { currentUrl },
        { alternateLangUrl },
    ); // eslint-disable-line
    window.location = alternateLangUrl;
};

const trimFormidableLabelIdFormidable = () => {
    const idFormidableFieldLabelEls = document.querySelectorAll(
        'label[id*="id_formidable"]',
    );
    if (!idFormidableFieldLabelEls) return;

    idFormidableFieldLabelEls.forEach((labelEl) => {
        labelEl.textContent = labelEl.textContent.trim();
    });
};

const trimFormidableSelectOptions = () => {
    const formidableFormWrapperEls = document.querySelectorAll(".frm_forms");
    if (!formidableFormWrapperEls) return;

    // faut pas enlever ce commentaire sinon ça fait merder la compilation WebPack... oui oui
    // franchement à ce stade, cherchez pas 🤷‍♂️
    formidableFormWrapperEls.forEach((formWrapperEl) => {
        const selectOptionEls = formWrapperEl.querySelectorAll("select option");
        selectOptionEls.forEach((optionEl) => {
            optionEl.textContent = optionEl.textContent.trim();
        });
    });
};
